
import { addresses as contractsJSON, } from "./contracts";
import abi from "./abi";

import { addresses as tokensJSON, definitions as tokenDefinitions, } from "./tokens";
import type { Address, Abi, } from "../types";

const tokens = tokensJSON as Record<keyof typeof tokensJSON, Address>;
const contracts = contractsJSON as Record<keyof typeof contractsJSON, Address>;
const addresses = Object.assign({}, contracts, tokens);

const interfaces: Record<keyof typeof abi, Abi["abi"]> = {
	ERC20: abi.ERC20.abi,
	Escrow: abi.Escrow.abi,
	Pricing: abi.Pricing.abi,
	BracketOracle: abi.BracketOracle.abi,
	UniswapV3Factory: abi.UniswapV3Factory.abi,
	UniswapV3Quoter: abi.UniswapV3Quoter.abi,
	EscrowRouter: abi.EscrowRouter.abi,
}


export {
	addresses,
	contracts,
	tokens,
	tokenDefinitions,
	interfaces,
};
